// Utilities
import analytics from '../utility/analyticsUtil'
import dialog from '../utility/dialogUtil'
import Language from './languageUtil'
import logger from '../utility/loggerUtil'

class AppBrowserUtil {
  static async openExternalPageInBrowser (url, name) {
    try {
      analytics.setScreenName(name)
      return AppBrowserUtil.openInBrowser(url, '_blank')
    } catch (e) {
      logger.error(`Error opening ${url} site link in browser`)
      logger.debug(e)
      dialog.errorAlert(Language.$t('global.app_browser_error'))
    }
  }

  /**
   * Opens a given URL.
   * @param {String} url - The URL to navigate to.
   * @param {String} target - Determines how to open the URL (possible values: '_self', '_default', '_system').
   */
  static openInBrowser (url, target) {
    const openedWindow = window.open(url, target)

    if (!openedWindow || openedWindow.closed || typeof openedWindow.closed === 'undefined') {
      logger.warn('Popup blocked. Returning false so calling code can handle this.')
      return false // different from 'undefined'
    }

    return undefined // 'undefined' if successfully opened popup
  }
}

export default AppBrowserUtil
